var   KEYS  = require('../../keys/Keys');
var   AXIOS = require('axios');

export {GetBrandsAsync as InvokeAsync , GetBrandsSync as InvokeSync}

async function GetBrandsAsync(LoginToken,LastKey)
{
    var GetBrandsPromise = new Promise((resolve, reject) => {
        GetBrandsSync(LoginToken,LastKey,(response,error) => {
            if (error) {  
                try{ 
                    return reject(error.response.data.message);
                }catch(ex){
                    return reject('Unknown error');
                }
            }
            if(response.status==='fails'){
                reject(response.error);
            }else{
                resolve(null);
            }
        });
    });

    return await GetBrandsPromise;
}

function GetBrandsSync(LoginToken,LastKey,Callback)
{
    AXIOS({
        headers:{
            'Content-Type': 'application/json',
            'x-api-key'   : KEYS.AWS_XKEY,
        },
        method : 'post',
        url    :'/Admin/GetBrands',                
        data  : {
            AppID     :KEYS.AWS_APPID,
            LastKey   :LastKey,
            LoginToken:LoginToken             
        },                                
    })
    .then((response)=>{
        Callback(response.data,null);
    },(error) => { 
        Callback(null,error + ' ');
    });
}
